/*
 * Ryan O'Dowd
 * 2025-12-19
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  appSchema,
  tableSchema,
} from '@nozbe/watermelondb';

const translations = tableSchema({
  name: 'translations', // @TODO: global const
  columns: [
    {name: 'translation_id', type: 'number'},
    {name: 'updated_at', type: 'number'},
    {name: 'is_full_download', type: 'boolean'},
  ],
});

const footnotes = tableSchema({
  name: 'footnotes', // @TODO: global const
  columns: [
    {name: 'footnote_id', type: 'number', isIndexed: true},
    {name: 'verse_text_id', type: 'number', isIndexed: true},
    {name: 'position_in_verse_text', type: 'number'},
    {name: 'is_in_heading', type: 'boolean'},
    {name: 'indicator', type: 'string'},
    {name: 'body', type: 'string'},
  ],
});

const verseTexts = tableSchema({
  name: 'verse_texts', // @TODO: global const
  columns: [
    {name: 'verse_id', type: 'number'}, // @TODO: indexed?
    {name: 'verse_api_id', type: 'string'},
    {name: 'book_id', type: 'number'}, // @TODO: would be nice not to include for every verse # @TODO: also redundant if we have verse_api_id
    {name: 'chapter_number', type: 'number'}, // @TODO: would be nice not to include for every verse # @TODO: also redundant if we have verse_api_id
    {name: 'verse_number', type: 'number'}, // @TODO: redundant if we have verse_api_id
    {name: 'verse_text_id', type: 'number'}, // @TODO: indexed?
    {name: 'verse_text', type: 'string'},
    {name: 'heading', type: 'string', isOptional: true},
    {name: 'translation_id', type: 'number'},
    {name: 'range_start_verse_number', type: 'number'},
    {name: 'range_end_verse_number', type: 'number'},
  ],
});

export default appSchema({
  version: 1,
  tables: [
    translations,
    footnotes,
    verseTexts,
  ],
});
